import React, { useState, useEffect } from "react";
import { EmailField } from "../../../components/input/fields/email-filed";
import TextField from "../../../components/input/fields/text-field";
import logo from '../../../content/img/logo.png';
import { IoEye, IoEyeOff } from 'react-icons/io5';
import { toast } from "react-toastify";
import { NavLink, useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth"; 
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import {
  sendPasswordResetEmail,
  confirmPasswordReset
} from "firebase/auth";

const ResetPassword = () => {
    const { t } = useTranslation();
    const auth = getAuth();
    const navigator = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const oobCode = queryParams.get('oobCode');
    const [changeFields, setChangeFields] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
  
    /* Fields */
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleSendPasswordResetEmail = async () => {
      if (!(email)) {
          toast.error(t("ToastErrorEmailRequired")); 
          return;
      }
      await sendPasswordResetEmail(auth, email).then(() => toast.success(t("ToastEmailSentSuccessfully")).then(() => setChangeFields(true)));
    };

    const handleResetPassword = async () => {
      if (!(password)) {
          toast.error(t("ToastErrorPasswordRequired")); 
          return;
      }
      if (!(confirmPassword)) {
          toast.error(t("ToastErrorConfirmPasswordRequired")); 
          return;
      }
      await confirmPasswordReset(auth, oobCode, confirmPassword)
        .then(function() {
          toast.success(t("ToastPasswordUpdatedSuccessfully")); 
        })
        .then(() => navigator("/login"))
        .catch(function() {
          toast.error(t("ToastPasswordUpdateError")); 
        });
    };

    useEffect(() => {
      if (oobCode) {
          setChangeFields(true);
      }
    }, [changeFields, oobCode]);

    return (
        <>
            <div className="container-login">
                <div className="row justify-content-center">
                    <div className="col-md-4">
                        <div className="mt-3">
                            <img
                                className="w-100 h-auto"
                                alt="Feeling Italy logo"
                                src={logo}
                            />
                        </div>
                        <h1 className="text-center title title-login">
                            {t("ResetPassword")}  
                        </h1>
                        {changeFields ? (
                          <>
                          <div className="d-flex flex-column mt-4">
                            <EmailField
                                onChange={(e) => setEmail(e.target.value)}
                                label={t("Email")}  
                                placeholder={t("Insert")}  
                                inputClassName={"form-control input-login grey-input"}
                                className={""}
                            />
                        </div>
                        <div className="w-full d-flex justify-content-between mt-3">
                          <NavLink to={"/login"}>
                            <button className="background-black text-white mt-3 py-2 px-5 text-left border-none">
                              <span className="ml-1 ms-2">{t("Back")}</span>  
                            </button>
                          </NavLink>
                            <button onClick={handleSendPasswordResetEmail} className="background-black text-white mt-3 py-2 px-5 text-left border-none">
                                {t("Send")}  
                            </button>
                        </div>
                        </>
                        ) : (
                          <>
                          <div className="d-flex flex-column mt-4 position-relative">
                                <TextField
                                    type={isPasswordVisible ? "text" : "password"}
                                    label={t("Password")}  
                                    placeholder={t("Insert")}  
                                    inputClassName={"form-control input-login grey-input"}
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                    }}
                                    value={password}
                                />
                                <button
                                    className="btn-eyePassword position-absolute"
                                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                >
                                    {isPasswordVisible ? <IoEyeOff className="fs-6 mt-2"/> : <IoEye className="fs-6 mt-2"/>}
                                </button>
                            </div>
                          <div className="d-flex flex-column mt-4 position-relative">
                                <TextField
                                    type={isConfirmPasswordVisible ? "text" : "password"}
                                    label={t("ConfirmPassword")}  
                                    placeholder={t("Insert")}  
                                    inputClassName={"form-control input-login grey-input"}
                                    onChange={(e) => {
                                        setConfirmPassword(e.target.value);
                                    }}
                                    value={confirmPassword}
                                />
                                <button
                                    className="btn-eyePassword position-absolute"
                                    onClick={() => setIsConfirmPasswordVisible(!isConfirmPasswordVisible)}
                                >
                                    {isConfirmPasswordVisible ? <IoEyeOff className="fs-6 mt-2"/> : <IoEye className="fs-6 mt-2"/>}
                                </button>
                            </div>
                            <div className="w-full d-flex justify-content-between mt-3">
                              <NavLink to={"/login"}>
                                <button className="background-black text-white mt-3 py-2 px-5 text-left border-none">
                                  <span className="ml-1 ms-2">{t("Back")}</span>  
                                </button>
                              </NavLink>
                                <button onClick={handleResetPassword} className="background-black text-white mt-3 py-2 px-5 text-left border-none">
                                    {t("Send")}  
                                </button>
                            </div>
                          </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
